import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { Users, GraduationCap, CheckSquare, Calendar as CalIcon } from "lucide-react";

const Stat = ({ label, value, icon: Icon, color, tid }) => (
  <div className="dec-card p-5" data-testid={tid}>
    <div className="flex items-center justify-between">
      <div className="text-xs uppercase tracking-wider text-[#5C6561]">{label}</div>
      <Icon className="w-4 h-4 text-[#5C6561]" />
    </div>
    <div className="mt-2 text-3xl font-bold text-[#1F2421]" style={{ color }}>{value}</div>
  </div>
);

export default function CoachDashboard() {
  const [s, setS] = useState(null);
  useEffect(() => {
    api.get("/coach/summary").then(({ data }) => setS(data));
  }, []);
  if (!s) return <div className="text-[#5C6561]">Chargement…</div>;
  return (
    <div>
      <div className="mb-8">
        <h1 className="font-serif-accent text-3xl sm:text-4xl text-[#1F2421]">Tableau de bord</h1>
        <p className="text-[#5C6561] mt-1">Un aperçu de votre coaching en un coup d'œil.</p>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <Stat tid="stat-total-learners" label="Apprenants" value={s.total_learners} icon={Users} color="#D95D39" />
        <Stat tid="stat-active-learners" label="Actifs" value={s.active_learners} icon={Users} color="#2A5B52" />
        <Stat tid="stat-completed-sessions" label="Séances terminées" value={s.completed_sessions} icon={GraduationCap} color="#E5983B" />
        <Stat tid="stat-completed-missions" label="Missions faites" value={`${s.completed_missions}/${s.total_missions}`} icon={CheckSquare} color="#1F2421" />
      </div>

      <div className="mt-10 dec-card p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="font-serif-accent text-2xl">Prochains cours</h2>
          <Link to="/coach/calendrier" className="text-sm text-[#D95D39] font-medium">Voir le calendrier →</Link>
        </div>
        {s.upcoming_events.length === 0 ? (
          <div className="text-[#5C6561] text-sm">Aucun cours planifié pour le moment.</div>
        ) : (
          <div className="space-y-2">
            {s.upcoming_events.map((e) => (
              <div key={e.id} className="flex items-center gap-4 p-3 rounded-xl bg-[#F4EFEA]">
                <CalIcon className="w-5 h-5 text-[#D95D39]" />
                <div className="flex-1">
                  <div className="font-medium">{e.title}</div>
                  <div className="text-xs text-[#5C6561]">{e.date} • {e.start_time} → {e.end_time}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
